export enum LoraGenderEnum {
  male = "male",
  female = "female",
}
